module.exports = __webpack_public_path__ + "img/check-square-fill.4db6d2d4.svg";